import React, { useRef } from 'react'
import { ArrowLeft, Save } from 'lucide-react'
import { Button } from '@pilot-hub/ui'

/** Abschnitt eines Formulars: Titel, optionale Beschreibung, Inhalt im Zweispalten-Raster (ab sm). */
export function FormSection({ titel, beschreibung, spalten = 2, children }: {
  titel?: string
  beschreibung?: string
  spalten?: 1 | 2
  children: React.ReactNode
}) {
  return (
    <section className="space-y-3">
      {(titel || beschreibung) && (
        <header>
          {titel && <h3 className="text-sm font-semibold text-dark-text">{titel}</h3>}
          {beschreibung && <p className="mt-0.5 text-xs text-dark-text-muted">{beschreibung}</p>}
        </header>
      )}
      <div className={`grid gap-4 ${spalten === 2 ? 'sm:grid-cols-2' : ''}`}>{children}</div>
    </section>
  )
}

/** Merkt sich den Stand beim Wechsel von `schluessel` (z. B. Ansicht) und meldet, ob sich `werte` seitdem geändert haben. */
export function useUngespeichert(werte: unknown, schluessel: string): boolean {
  const basis = useRef<string>('')
  const key = useRef<string | null>(null)
  let json = ''
  try { json = JSON.stringify(werte) } catch { json = '' }
  if (key.current !== schluessel) { key.current = schluessel; basis.current = json }
  return basis.current !== json
}

/** Feste Aktionsleiste am unteren Rand der Bearbeiten-/Anlegen-Ansichten (am Handy oberhalb des Docks). */
export function FormAktionsleiste({ geaendert, speichert, speichernGesperrt, onSpeichern, onAbbrechen }: {
  geaendert: boolean
  speichert: boolean
  speichernGesperrt?: boolean
  onSpeichern: () => void
  onAbbrechen: () => void
}) {
  const abbrechen = () => {
    if (geaendert && !window.confirm('Ungespeicherte Änderungen verwerfen?')) return
    onAbbrechen()
  }
  return (
    <div className="admin-aktionsleiste sticky z-30 -mx-1 mt-2 flex flex-wrap items-center gap-3 rounded-xl border border-dark-border bg-dark-bg-secondary/95 px-4 py-3 shadow-lg backdrop-blur" data-testid="form-aktionsleiste">
      <span className={`mr-auto text-sm ${geaendert ? 'text-amber-300' : 'text-dark-text-subtle'}`} role="status">
        {geaendert ? '● Ungespeicherte Änderungen' : 'Keine Änderungen'}
      </span>
      <Button variant="secondary" onClick={abbrechen}><ArrowLeft className="mr-1 h-4 w-4" />Abbrechen</Button>
      <Button onClick={onSpeichern} disabled={speichert || speichernGesperrt}><Save className="mr-1 h-4 w-4" />{speichert ? 'Speichern…' : 'Speichern'}</Button>
    </div>
  )
}
